import BookingButton from "./BookingButton";

const PHOTOS = [
  {
    src: "/assets/community/community-meditation-field.jpg",
    alt: "Woman of color sitting in quiet meditation outdoors, surrounded by plants.",
    caption: "Stress + nervous system",
  },
  {
    src: "/assets/community/community-portrait-1.jpg",
    alt: "Latina woman in a soft white shirt, eyes closed, restful.",
    caption: "Sleep + hormonal balance",
  },
];

export default function Community() {
  return (
    <section
      className="py-24 lg:py-32 border-y"
      style={{ background: "var(--sano-bg-2)", borderColor: "var(--sano-border)" }}
      data-testid="community-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-4">Who we treat</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              A practice for <em className="italic" style={{ color: "var(--sano-olive)" }}>New York</em>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
              We treat New York professionals with busy lives — juggling family,
              work, and social life. The kind of full days that leave the
              nervous system running past midnight. You belong here.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-10 max-w-4xl">
          {PHOTOS.map((p, i) => (
            <figure
              key={i}
              className="group relative overflow-hidden"
              data-testid={`community-photo-${i}`}
            >
              <div
                className="aspect-[3/4] overflow-hidden"
                style={{ background: "var(--sano-border)" }}
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="mt-3 text-xs uppercase tracking-widest" style={{ color: "var(--sano-ink-2)" }}>
                {p.caption}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap items-center gap-4">
          <BookingButton testid="community-book-btn" />
          <span className="text-sm" style={{ color: "var(--sano-ink-2)" }}>
            English, Spanish, and the dialect of the body welcome here.
          </span>
        </div>
      </div>
    </section>
  );
}
